<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Apotik" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <!--PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          /-->
          <div class="page-content-title no-print">
            <div class="left">
              <div>
                <h4 class="title mb-0">Apotik</h4>
              </div>
            </div>
            <div class="action">
              <span
                ><span
                  ><a
                    @click="createNew"
                    class="btn btn-primary btn-with-icon-left ml-2"
                    ><i class="material-symbols-outlined">add</i> Pembelian Baru
                  </a></span
                ></span
              >
            </div>
          </div>

          <div>
            <div class="row mb-4">
              <div class="col-md-12">
                <!-- @include('blocks.tabs') -->
                <b-tabs pills>
                  <b-tab
                    v-for="item in tabs"
                    v-bind:key="item.title + String(Math.random(1023))"
                    :title="item.title"
                    @click="() => filterTab(item.filter)"
                    :active="item.filter == status"
                  />
                </b-tabs>
              </div>
              <!-- <div class="col-md-5">
                <div class="row">
                  <div class="col-md-5 px-1">
                    <div class="card">
                      <div class="card-body p-3">
                        <h5 class="mb-1">Rekapitulasi Resep Obat</h5>
                        <h4 class="text-primary mb-0">{{nResep}} Resep Obat</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7 px-1">
                    <div class="card">
                      <div class="card-body p-3">
                        <h5 class="mb-1">Rekapitulasi Obat Berdasarkan Jenis</h5>
                        <h4 class="text-secondary mb-0">{{nObat}} Obat</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-10">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-2">
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="rows.length > 10" value="25">
                        25 data
                      </option>
                      <option v-if="rows.length > 25" value="50">
                        50 data
                      </option>
                      <option v-if="rows.length > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <datatable
              v-if="loaded && rows.length"
              :columns="columns"
              :per-page="parseInt(perPage)"
              :data="rows"
              :filter="filter"
              class="table table-hover responsive"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{ size: 'small' }"
            />
            <Loading v-else />
            <br />
            <p v-if="rows.length">
              Menampilkan
              {{ countTotalRows }} data dari total {{ rows.length }} data
            </p>
            <datatable-pager
              v-if="loaded && rows.length"
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
            ></datatable-pager>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
// import PageContentHeader from "@/components/PageContentHeader.vue";
import { toCapitalize, getInputDate } from "@/data/helper.js";
import FormRow from "@/components/FormRow.vue";
// import { HTTP } from "@/config.js";
import { data, tabs, filters, sort } from "@/data/Apotik.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "Apotik",
  components: {
    Navbar,
    Sidebar,
    // PageContentHeader,
    FormRow,
    Loading,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      loaded: false,
      toCapitalize: toCapitalize,
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      created_from: getInputDate(),
      created_to: getInputDate(),
      orderBy: "desc",
      status: "SEMUA",
      nResep: 0,
      nObat: 0,
      columns: [
        {
          label: "No",
          field: "number",
        },
        { label: "No Rawat", field: "no_rawat" },
        {
          label: "No. RM",
          field: "no_rm",
          headerClass: "class-in-header second-class",
        },
        { label: "Pasien", field: "pasien_nama" },
        { label: "JK", field: "pasien_jen_kelamin" },
        {
          label: "Tebus Obat",
          representedAs: (item) => `${item.rawat_jalan_obat}`,
          interpolate: true,
        },
        // { label: "Total Harga", field: "formatted_sub_total" },
        { label: "Total Bayar", field: "tagihan_ringkasan_total_bayar" },
        { label: "Status", field: "tagihan_ringkasan_status" },
        {
          label: "",
          class: "dropdown",
          representedAs: (
            item
          ) => `<a class="btn btn-sm btn-success btn-icon" href="/#/apotik/detail/${item.ralan_id}?fromTab=${item.fromTab}&id_ringkasan=${item.id_tagihan_ringkasan}"><i class="material-symbols-outlined">open_in_new</i></a>
                <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
                    <i class="material-symbols-outlined">apps</i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
                    <a class="dropdown-item" href="/#/apotik/detail/${item.ralan_id}?fromTab=${item.fromTab}&id_ringkasan=${item.id}">
                        <i class="material-symbols-outlined">open_in_new</i>
                        Detail Resep Obat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/cetak-resep-obat/${item.ralan_id}" target="_blank">
                        <i class="material-symbols-outlined">print</i>
                        Cetak Resep Obat
                    </a>
                </div>`,
          interpolate: true,
        },
        // {label: 'Address', representedAs: ({address, city, state}) => `${address}<br />${city}, ${state}`, interpolate: true}
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
    };
  },
  methods: {
    createNew: async function() {
      try {
        let result = await this.$store.state.HTTP.post(
          "ralan/resep/obat/pembelian-langsung"
        );
        //console.log(result);
        if (result.status == "200" && result.data && result.data.id) {
          //console.log(result.data);
          this.$router.push({
            path: `/apotik/detail/${result.data.id}?fromTab=SEMUA`,
          });
        } else {
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        this.errors.push(e);
        this.loaded = true;
      }
    },
    countRows() {
      let that = this;
      setInterval(function() {
        let count = document.querySelectorAll(
          ".table-responsive table.responsive tbody>tr"
        ).length;
        if (that.countTotalRows != count) {
          that.countTotalRows = count;
        }
      }, 1000);
    },
    async filterTab(filter) {
      //console.log(filter);
      this["status"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
      // this.$nextTick(() => {
      //   if (this.$refs.focusMe) {
      //     this.$refs.focusMe.focus();
      //   }
      // });
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      let params = `?per_page=999999999999&orderBy=${this.orderBy}`;
      // updated from and created to filter
      if (this.created_from) {
        params += `&updated_from=${this.created_from}`;
      } else {
        params += `&updated_from=null`;
      }
      if (this.created_to) {
        params += `&updated_to=${this.created_to}`;
      } else {
        params += `&updated_to=null`;
      }
      // updated from and created to filter
      if (this["status"]) {
        if (this["status"].toUpperCase() != "SEMUA") {
          params += `&status=${this.status}`;
        }
      }
      try {
        let result = await this.$store.state.HTTP.get("menu/apotik" + params);
        //console.log(JSON.stringify(result));
        if (result.status == "200") {
          //console.log("berhasil");

          let self = this;
          //console.log(result.data);
          this.rows = result.data.map((item, index) => {
            item.number = index + 1;
            item.fromTab = self.status;
            return item;
          });
          //console.log(this.rows);
          //console.log(this.rows)
          this.loaded = true;
          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.countRows();
    if (this.$route.query.tab) {
      this.status = this.toCapitalize(this.$route.query.tab);
      ////console.log(this.status);
    }
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
